import themeGet from '@styled-system/theme-get';
import styled from 'styled-components/macro';

const QualificationBanner = styled.aside`
  background-color: ${themeGet('colors.foundation.primaryDefault')};
  background-image: url(${({ banner }) => banner});
  background-position: center;
  background-size: cover;
  bottom: 0;
  height: 100vh;
  position: fixed;
  right: 0;
  top: 0;
  width: 376px;
  @media (max-width: 1080px) {
    display: none;
  }
`;

export default QualificationBanner;
